<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import { VueEditor, Quill } from 'vue2-editor'
export default
{
    computed: mapGetters({ data: 'generalConfig' }),

    components: { VueEditor },

    methods:
    {
        save()
        {
            axios.post(process.env.API_URL + '/v1/admin/settings', this.data).then(res => {
                this.$store.dispatch('fetchSettings')
            })
        },

        clearCache()
        {
            axios.post(process.env.API_URL + '/v1/admin/cache-clear').then((res) => {
              this.$snotify.success('Cache cleared')
            })
        },

        addFile(key, file)
        {
            this.$set(this.data[key], 'value', file.display_url)
            this.$forceUpdate()
        }
    },

    data() {
        return {
            editorSettings: {
                imageResize: {},
            },
        }
    }

}
</script>

<template>
    <div class="container-fluid">
        <div class="panel panel-primary">
            <div class="panel-heading">
                <div class="row">
                    <div class="col-sm-12">
                        <h4>{{ $t('MENU.SETTINGS') }}</h4>
                    </div>
                </div>
            </div>
            <div class="panel-body">
                <form @submit.prevent.stop="save">
                    <div class="form-group row" v-for="(obj, key) in data" :key="key" v-if="key && !key.includes('main_page_')">
                        <label class="col-md-4 control-label">
                            {{ $t('SETTINGS.' + key) }}
                        </label>
                        <div class="col-md-6">
                            <mv-date-time-picker v-if="obj.type == 'date'" v-model="data[key].value" />
                            <input type="checkbox" v-else-if="obj.type == 'boolean'" v-model="data[key].value" />
                            <textarea class="form-control" v-else-if="obj.type == 'textarea'" v-model="data[key].value"></textarea>
                            <div v-else-if="obj.type == 'file'">
                                <img :src="data[key].value" style="width: 100%; max-width: 360px;">
                                <label class="btn btn-sm btn-primary">
                                  <mv-uploader ref="uploader" multiple @upload-done="addFile(key, $event)" accept="image/*" type="media"></mv-uploader>
                                  <icon name="file"></icon>
                                </label>
                            </div>
                            <vue-editor
                              :id="`editor-${key}`"
                              v-else-if="obj.type == 'html'"
                              :editorOptions="editorSettings"
                              v-model="data[key].value">
                            </vue-editor>
                            <input class="form-control" v-else type="text" v-model="data[key].value">
                        </div>
                    </div>
                    <div class="form-group row">
                        <div class="col-md-6">
                            <button class="btn btn-danger" @click.prevent.stop="clearCache">Clear Cache</button>
                        </div>
                        <div class="col-md-6 text-right">
                            <button class="btn btn-success">{{ $t('GENERAL.SAVE') }}</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/pages/Settings.vue